export default {
    template: [
        'PROFILE_TEMPLATE',
        data => ({
            id: data.id,
            language: data.language,
            degrees: data.degrees,
        }),
    ],
    authorize: true,
    POST: {},

    '/:id': {
        GET: {},
        PUT: {},
    },
};
